import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MatTimezoneDateRangePickerComponent } from './components/timezone-date-range-picker.component';
import { DateOnlyAdapter } from './DateOnlyAdapter';
import { TimezoneDatepickerDirective } from './directives/timezone-datepicker.directive';
import { TimezoneEndDatepickerDirective } from './directives/timezone-end-datepicker.directive';
import { TimezoneStartDatepickerDirective } from './directives/timezone-start-datepicker.directive';
import { MomentDateHttpInterceptor } from './interceptors/moment-date.interceptor';
import { MatTimezoneDatePipe } from './pipes/timezone-date.pipe';
import { TimezoneDateAdapter } from './TimezoneDateAdapter';


const DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'MM-DD-YY',
    },
    display: {
        dateInput: 'MM-DD-YY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        MatTimezoneDatePipe,
        TimezoneDatepickerDirective,
        TimezoneStartDatepickerDirective,
        TimezoneEndDatepickerDirective,
        MatTimezoneDateRangePickerComponent,
    ],
    providers: [
        MatTimezoneDatePipe,
    ],
    exports: [
        MatTimezoneDatePipe,
        TimezoneDatepickerDirective,
        TimezoneStartDatepickerDirective,
        TimezoneEndDatepickerDirective,
        MatTimezoneDateRangePickerComponent,
    ],
})
export class TimezoneModule {
    static forRoot(): ModuleWithProviders<TimezoneModule> {
        return {
            ngModule: TimezoneModule,
            providers: [
                TimezoneDateAdapter,
                DateOnlyAdapter,
                { provide: MAT_DATE_LOCALE, useValue: 'en-us' },
                { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
                { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
                { provide: DateAdapter, useExisting: TimezoneDateAdapter },
                { provide: HTTP_INTERCEPTORS, useClass: MomentDateHttpInterceptor, multi: true },
            ],
        };
    }
}